import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "动漫资讯", to: "/news" },
  { label: "动漫作品", to: "/anime" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const submitSearch = () => {
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${
      isActive
        ? "text-primary-700 bg-primary-50"
        : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-600 text-background-50">
            <i className="ri-fire-fill text-xl"></i>
          </span>
          <span className="font-brand text-xl text-primary-800 leading-none">火狼动漫网</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.to === "/"} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <div className="flex items-center gap-2 h-10 px-3 rounded-full bg-background-100 border border-background-200 focus-within:border-primary-300 transition-colors">
            <span className="w-4 h-4 flex items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") submitSearch();
              }}
              placeholder="搜索动漫 / 资讯"
              className="w-36 lg:w-44 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
            />
          </div>
          <button
            type="button"
            onClick={submitSearch}
            className="h-10 px-4 rounded-full bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            搜索
          </button>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 wf-fade-in">
          <div className="flex items-center gap-2 h-11 px-3 mb-3 rounded-full bg-background-100 border border-background-200">
            <span className="w-4 h-4 flex items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") submitSearch();
              }}
              placeholder="搜索动漫 / 资讯"
              className="flex-1 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
            />
            <button
              type="button"
              onClick={submitSearch}
              className="text-sm font-medium text-primary-700 whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </div>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-sm font-medium ${
                    isActive ? "text-primary-700 bg-primary-50" : "text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}